export default __webpack_public_path__ + "static/media/edit-profile.236984a0.svg";